import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=c0227de8&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=c0227de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0227de8",
  null
  
)

export default component.exports